import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CommercialPermitService } from '../../../services/commercial-permit.service';
import { MvdModalService } from '../../../../shared/services/modal/mvd-modal.service';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { LazyLoadEvent } from 'primeng/api';
import { CommercialVehiclePermitNumberModel } from '@max/commercialpermitting/models/commercial-vehicle-permit-number.model';

export class HistoricalCommercialVehiclePermitNumberContext {
    constructor(public vehicleId: number) { }
}

@Component({
    templateUrl: './historical-commercial-vehicle-permit-number-modal.html',
    selector: ''
})
export class HistoricalCommercialVehiclePermitNumberModalComponent extends BaseComponent {
    // Gets or sets the vehicle Id
    public vehicleId: number;

    // Gets or sets the previous page number to -1 value.
    public previousPage = -1;

    // Gets or sets the data store
    public dataStore: any = [];

    // Gets or sets the CommercialVehiclePermitNumberViewModel
    public commercialVehiclePermitNumberViewModel: CommercialVehiclePermitNumberModel[];

    // Gets or sets the total records for the page count.
    public totalRecords: number;

    // Gets or sets the text for filter value.
    public previousFliter = '';

    constructor(public commercialPermitService: CommercialPermitService,
        public dialogRef: MatDialogRef<HistoricalCommercialVehiclePermitNumberModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalCommercialVehiclePermitNumberContext,
        public modalService: MvdModalService) {
        super();

        this.vehicleId = this.data.vehicleId;
    }

    ngOnInit() {

    }

    /**
     * Populates the CML permits paginated.
     * @param customerNumberId
     * @param event
     */
    public populateCMLPermits(event: LazyLoadEvent) {
        var pageNumber = event.first / 10;

        if (pageNumber > this.previousPage) {
            this.commercialPermitService.getCommercialPermitVehicleInformation(this.vehicleId, pageNumber).subscribe(
                result => {
                    this.dataStore.push(...result.result);
                    this.displayResults = true;

                    this.commercialVehiclePermitNumberViewModel = this.dataStore.slice(event.first, (event.first + event.rows));

                    if (result.result.length > 0) {
                        this.totalRecords = (pageNumber + 1) * 10 + 1;
                    }
                },
                error => {
                    console.log('error', error);
                });
            this.previousPage = pageNumber;
        } else {
            this.commercialVehiclePermitNumberViewModel = this.dataStore.slice(event.first, (event.first + event.rows));
        }
    }

    /** Cancel button */
    public cancel() {
        this.dialogRef.close();
    }
}
